import {FormElement} from "./form-element.js";

/**
 * Represents an area element, specifically a textarea element, which is part of a form.
 * This class extends the `FormElement` class, inheriting its properties and behavior.
 * It provides customization for textarea-specific attributes such as `rows`.
 */
export class AreaElement extends FormElement {
    componentTag = "textarea";
    rows;

    /**
     * Constructs an instance of the class and initializes it with the provided parameters.
     *
     * @param {Object} formData - The data object used to populate the form.
     * @param {HTMLElement} parentElement - The parent HTML element where the form will be appended.
     * @param {Array} collection - A collection associated with the form to manage or process data.
     * @return {void}
     */
    constructor(formData, parentElement, collection) {
        super(formData, parentElement, collection);
    }

    /**
     * Configures the attributes of the given component.
     *
     * @param {Object} component - The component to which attributes will be applied.
     * @return {void}
     */
    attributes(component) {
        super.attributes(component);
        component.name = this.dataField;

        if ((this.rows ?? 0) > 0) {
            component.rows = this.rows;
        }
    }
}